module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Jack Compton’s Luck")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "pdlmsr.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "adCardPage",
    attrs: {
      "id": "adc01"
    }
  }, [_c('h2', {
    staticClass: "adCardHead"
  }, [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Available from Harlequin")])]), _c('sup', [_vm._v("®")]), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Historical and"), _c('br'), _vm._v("\nPAULA MARSHALL")])])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Rinaldi’s Revenge")])]), _vm._v(" #133")])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('span', {
    staticClass: "footnoteRef"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/footnote1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])])]), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("An Unconventional Heiress")])]), _vm._v(" #141")])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('span', {
    staticClass: "footnoteRef"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/footnote2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])])]), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Hester Waring’s Marriage")])]), _vm._v(" #147")])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('span', {
    staticClass: "footnoteRef"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/footnote3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])])]), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("A Strange Likeness")])]), _vm._v(" #153")])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('span', {
    staticClass: "footnoteRef"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/footnote4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])])]), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("An Innocent Masquerade #158")])])])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("The Astrologer’s Daughter")])]), _vm._v(" #172")])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('span', {
    staticClass: "footnoteRef"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/footnote5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])])]), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("His One Woman")])]), _vm._v(" #181")])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('span', {
    staticClass: "footnoteRef"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/footnote6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])])]), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("The Dollar Prince’s Wife")])]), _vm._v(" #185")])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('span', {
    staticClass: "footnoteRef"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/footnote7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("*")])])]), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Prince of Secrets #189")])])])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_c('span', {
    staticClass: "footnoteRef"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/footnote8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("**")])])]), _vm._v("Maid of Honor #198")])])])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('span', {
    staticClass: "footnoteRef"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/footnote9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("**")])])]), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("The Black Sheep’s Bride")])]), _vm._v(" #212")])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("The Daring Duchess")])]), _vm._v(" #215")])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Major Chancellor’s Mission")])]), _vm._v(" #224")])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Lord Hadleigh’s Rebellion")])]), _vm._v(" #228")])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("The Devil and Drusilla")])]), _vm._v(" #241")])]), _c('p', {
    staticClass: "adCardText"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Jack Compton’s Luck")])]), _vm._v(" #260")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea4861d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/jackcomptonsluck_adc01.vue
// module id = 69
// module chunks = 0